import { registerLayout, ViewType } from '@kunlun/dependencies';

export const install = () => {
  registerLayout(
    `
      <view type="TABLE">
        <pack widget="group">
          <view type="SEARCH">
              <element widget="search" slot="search" slotSupport="field" />
          </view>
        </pack>
        <element widget="actionBar" slot="actionBar" slotSupport="action">
          <xslot name="actions" slotSupport="action" />
        </element>
        <element widget="TopHotSaleItemManageTable" slot="table">
        </element>
      </view>
    `,
    {
      viewType: ViewType.Table,
      model: "deli.aries.platform.DeliAriesPlatformTopHotSaleItemManageProxy",
      name: "itemManageList",
    }
  );
};

install();
